// extracted by mini-css-extract-plugin
module.exports = {"container":"AuthPageLayout_container__D4MQc","light":"AuthPageLayout_light__1gjXL","content":"AuthPageLayout_content__VcBVb"};